import { useDebounceDeepNull } from 'hooks/useDebounce';
import svcs from 'services';
import useSWR from 'swr';
import { nulllist } from 'util/ssqutil';
/*


{
  "result": [
    {
      "modifyDate": 20250219043411,
      "weight": 22,
      "addInfo": "",
      "type": "auto",
      "modifyUser": "promanager",
      "input": "index",
      "highlight": "<b class='search highlight'>전</b>병칠",
      "service": "index_ko",
      "useYn": "y",
      "createUser": "promanager",
      "autoNo": 37310,
      "word": "전병칠",
      "createDate": 20250219043411
    }
  ],
  "isOk": true,
  "count": 5
}

| 요청변수 | 설명(Desc)    |     | default | value  | 비고                              |
| -------- | ------------- | --- | ------- | ------ | --------------------------------- |
| query    | 자동완성 단어 |     | -       | String |                                   |
| service  | 대상 서비스   |     | -       | String | index_ko / index_en / index_en-us |
*/

export interface IfSrchV3AutoQueryRow {
  // modifyDate: number;
  // weight: number;
  // addInfo: string;
  // type: string;
  // modifyUser: string;
  // input: string;
  highlight: string;
  // service: string;
  // useYn: string;
  // createUser: string;
  // autoNo: number;
  word: string;
  //createDate: number;
}

interface IfSrchV3AutoQueryRes {
  result: IfSrchV3AutoQueryRow[];
  isOk: boolean;
  count: number;
}

const getAutoQueryService = (lang: string) => {
  if (lang === 'ko-KR') return 'index_ko';
  if (lang === 'en-US') return 'index_en-us';
  return 'index_en';
};

export const useApiSrchV3AutoQuery = (show: boolean, query: string) => {
  const debounceQuery = useDebounceDeepNull(show ? query : null, 500);
  const lang = svcs.svcLang.lang();
  const { data, isLoading, error } = useSWR<IfSrchV3AutoQueryRes>(
    show &&
      debounceQuery &&
      debounceQuery.length >= 2 && [
        '/api/guest/srch/v3/autoQuery',
        { query: debounceQuery, service: getAutoQueryService(lang) },
      ]
  );
  return {
    list: data?.result ?? (nulllist as IfSrchV3AutoQueryRow[]),
    isLoading,
    error,
  };
};
